import React from 'react'
import {findDOMNode} from "react-dom"

import NavigationMenuAddPopover, {
    NavigationMenuInlineAddParams,
    NavigationMenuInlineAddType
} from "../../menu-add-with-popover/popover"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../core/gd-components/buttons/control-button/control-button-standard";
import {ControlButtonSize} from "../../../../../core/gd-components/buttons/control-button/@types";

type Props = {
    className?      : string

    projectId       : ID

    parent?         : any

    onAddInline?    : {(inlineAddType: NavigationMenuInlineAddType, projectId?: ID, params?: NavigationMenuInlineAddParams):void}
}

type State = {
    showPopover: boolean
}

export default class NavigationMenuItemProjectAddMenu extends React.Component<Props, State> {


    constructor(props: Props) {
        super(props)

        this.state = {
            showPopover: false
        }
    }

    showPopover = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!this.state.showPopover) this.setState({showPopover: true})

        // highlight menu
        if (!this.props.parent.state.hovered) this.props.parent.setState({hovered: true})
    }

    hidePopover = () => {
        if (this.state.showPopover) this.setState({showPopover: false})

        // hide parent menu highlight
        if (this.props.parent.state.hovered) this.props.parent.setState({hovered: false})
    }

    onAddInline = (inlineType: NavigationMenuInlineAddType, params?: NavigationMenuInlineAddParams) => {
        this.props.onAddInline && this.props.onAddInline(inlineType, this.props.projectId, params)
        this.hidePopover()
    }

    renderPopover = () => {
        if (this.state.showPopover) {
            return <NavigationMenuAddPopover projectId        = {this.props.projectId}
                                             getTargetFunc    = {()=>findDOMNode(this)}
                                             hidePopover      = {this.hidePopover}
                                             onAddInline      = {this.onAddInline}/>
        }
    }

    render() {

        const classes = Classes('menu-add', this.props.className, {
            'popover-shown': this.state.showPopover
        })

        return (
            <ControlButtonStandard type={ControlButtonType.PLUS} size={ControlButtonSize.SIZE_24} onClick={this.showPopover} className={classes}>
                {this.renderPopover()}
            </ControlButtonStandard>
        )

        // const classes = Classes('menu-add ui5-ico-add', this.props.className, {
        //     'popover-shown': this.state.showPopover
        // })
        //
        // return (
        //     <div className={classes} onClick={this.showPopover}>
        //         {this.renderPopover()}
        //     </div>
        // )


    }
}
